import { Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";

import Loading from "../views/loading/Loading";
import {
  AusOverseas,
  AmlBlog,
  FxRateBlog,
  CashRemittanceBlog,
  SpecialBlog,
  InternationalMoney,
  MidMarketBlog,
} from "../views/Blogs/blogpost/april/route";
import {
  PanamaCanal,
  AiCanda,
  EconomicOutlook,
  DominicanRepublic,
  MexicoGrowth,
  Epocket,
  GhanaEconomy,
  NigeriaEconomy,
  SouthAfricaEconomy,
  Melbourne,
} from "../views/Blogs/blogpost/june/route";
import {
  ScamBlog,
  MoneyTransfer,
  PropertyOverseas,
  ThailandBlog,
} from "../views/Blogs/blogpost/july/route";
import { SwitchingRemittance } from "../views/Blogs/blogpost/august/route";
import { Story, StoryWall, TandCStory } from "../views/Story/route";

export const Router = () => {
  const Remittance = lazy(() => import("../views/Remittance/Remittance"));
  const Vault = lazy(() => import("../views/Vault/Vault"));
  const Ept = lazy(() => import("../views/EPT/Ept"));
  const TandC = lazy(() => import("../views/T&C/TandC"));

  const Privacy = lazy(() => import("../views/Privacy/Privacy"));
  const Home = lazy(() => import("../views/home/Home"));
  const ProductDisclosure = lazy(() =>
    import("../views/ProductDisclosure/ProductDisclosure")
  );

  const About = lazy(() => import("../views/About/About"));
  const EuAbout = lazy(() => import("../views/eu/About/About"));

  // europe version

  const EuHome = lazy(() => import("../views/eu/home/Home"));
  const EuRemittance = lazy(() => import("../views/eu/Remittance/Remittance"));

  const EuAml = lazy(() => import("../views/eu/Legal/Aml"));
  const EuTandC = lazy(() => import("../views/eu/Legal/UserAgreement"));
  const PrivacyPollicy = lazy(() => import("../views/eu/Legal/PrivacyPollicy"));
  const EuCookie = lazy(() => import("../views/eu/Legal/Cookie"));

  //blogs
  const Blog = lazy(() => import("../views/Blogs/Blog"));
  const FeaturedPost = lazy(() =>
    import("../views/Blogs/blogpost/FeaturedPost")
  );

  const Africa = lazy(() => import("../views/Blogs/blogpost/africa"));

  const Guinea = lazy(() => import("../views/Blogs/blogpost/Guinea"));

  const Benin = lazy(() => import("../views/Blogs/blogpost/Benin"));

  const Burkina = lazy(() => import("../views/Blogs/blogpost/Burkina"));

  const Cameroon = lazy(() => import("../views/Blogs/blogpost/Cameroon"));

  const Cote = lazy(() => import("../views/Blogs/blogpost/Cote"));

  const Congo = lazy(() => import("../views/Blogs/blogpost/Congo"));

  const Ghana = lazy(() => import("../views/Blogs/blogpost/Ghana"));

  const Kenya = lazy(() => import("../views/Blogs/blogpost/Kenya"));

  const Liberia = lazy(() => import("../views/Blogs/blogpost/Liberia"));

  const Malawi = lazy(() => import("../views/Blogs/blogpost/Malawi"));

  const Rwanda = lazy(() => import("../views/Blogs/blogpost/Rwanda"));

  const Senegal = lazy(() => import("../views/Blogs/blogpost/Senegal"));

  const Sudan = lazy(() => import("../views/Blogs/blogpost/Sudan"));

  const Tanzania = lazy(() => import("../views/Blogs/blogpost/Tanzania"));

  const Uganda = lazy(() => import("../views/Blogs/blogpost/Uganda"));

  const Zambia = lazy(() => import("../views/Blogs/blogpost/Zambia"));

  ///// blogs of airtel money,mtn,moov,cash pick up and vodafone.
  const TanzaniaAirtel = lazy(() =>
    import("../views/Blogs/blogpost/TanzaniaAirtel")
  );

  const IvoryMTN = lazy(() => import("../views/Blogs/blogpost/IvoryMTN"));

  const BeninMoov = lazy(() => import("../views/Blogs/blogpost/BeninMoov"));

  const CameroonMtn = lazy(() => import("../views/Blogs/blogpost/CameroonMtn"));

  const GhanaMtn = lazy(() => import("../views/Blogs/blogpost/GhanaMtn"));

  const SenegalOMM = lazy(() => import("../views/Blogs/blogpost/SengalOMM"));

  const LiberiaMtn = lazy(() => import("../views/Blogs/blogpost/LiberiaMtn"));

  const GhanaVodafone = lazy(() =>
    import("../views/Blogs/blogpost/GhanaVodafone")
  );

  const GhanaCpu = lazy(() => import("../views/Blogs/blogpost/GhanaCpu"));

  const SudanGurush = lazy(() => import("../views/Blogs/blogpost/SudanGurush"));

  const RwandaAirtel = lazy(() =>
    import("../views/Blogs/blogpost/RwandaAirtel")
  );

  const CongoAirtel = lazy(() => import("../views/Blogs/blogpost/CongoAirtel"));

  const KeneyaBt = lazy(() => import("../views/Blogs/blogpost/KeneyaBt"));

  const MalawiAirtel = lazy(() =>
    import("../views/Blogs/blogpost/MalawiAirtel")
  );

  const GhanaZeepay = lazy(() => import("../views/Blogs/blogpost/GhanaZeepay"));

  const TanzaniaVodacom = lazy(() =>
    import("../views/Blogs/blogpost/TanzaniaVodacom")
  );

  const CameroonOrange = lazy(() =>
    import("../views/Blogs/blogpost/CameroonOrange")
  );
  const GhanaBt = lazy(() => import("../views/Blogs/blogpost/GhanaBt"));

  const KeneyaMPESA = lazy(() => import("../views/Blogs/blogpost/KeneyaMPESA"));

  const GhanaAirtel = lazy(() => import("../views/Blogs/blogpost/GhanaAirtel"));

  const BurkinaMtn = lazy(() => import("../views/Blogs/blogpost/BurkinaMtn"));

  const UgandaMtn = lazy(() => import("../views/Blogs/blogpost/UgandaMtn"));

  const BeninMtn = lazy(() => import("../views/Blogs/blogpost/BeninMtn"));

  const CongoOrange = lazy(() => import("../views/Blogs/blogpost/CongoOrange"));

  const UgandaOrange = lazy(() =>
    import("../views/Blogs/blogpost/UgandaOrange")
  );

  const GuineaOrange = lazy(() =>
    import("../views/Blogs/blogpost/GuineaOrange")
  );
  const DebitCardBlog = lazy(() => import("../views/Blogs/blogpost/DebitCard"));

  //philippline blog
  const PhilippinesLiving = lazy(() =>
    import("../views/Blogs/blogpost/philippine/Living")
  );

  const PhilippinesHealth = lazy(() =>
    import("../views/Blogs/blogpost/philippine/Health")
  );

  const PhilippinesRetirement = lazy(() =>
    import("../views/Blogs/blogpost/philippine/Retirement")
  );

  const PhilippinesEducation = lazy(() =>
    import("../views/Blogs/blogpost/philippine/Education")
  );

  const PhilippinesFamily = lazy(() =>
    import("../views/Blogs/blogpost/philippine/Family")
  );

  const ThaiFood = lazy(() => import("../views/Blogs/blogpost/food/ThaiFood"));

  // India blog
  const RamMandir = lazy(() =>
    import("../views/Blogs/blogpost/india/RamMandir")
  );

  const IndianEconomy = lazy(() =>
    import("../views/Blogs/blogpost/india/IndianEconomy")
  );

  const IndonesiaCusine = lazy(() =>
    import("../views/Blogs/blogpost/indonasia/Cuisine")
  );

  const IndonesiaBali = lazy(() =>
    import("../views/Blogs/blogpost/indonasia/Bali")
  );

  const IndonesiaCultural = lazy(() =>
    import("../views/Blogs/blogpost/indonasia/Cultural")
  );

  const ThailandBeaches = lazy(() =>
    import("../views/Blogs/blogpost/thailand/ThailandBeach")
  );

  const ThailandCulture = lazy(() =>
    import("../views/Blogs/blogpost/thailand/ThailandCulture")
  );

  const ThailandTemple = lazy(() =>
    import("../views/Blogs/blogpost/thailand/ThailandTemple")
  );

  const ThailandBangkok = lazy(() =>
    import("../views/Blogs/blogpost/thailand/ThailandBangkok")
  );

  /** faq section */
  const FaqSection = lazy(() => import("../views/Faq/pages/FaqSection"));
  const EuFaqSection = lazy(() => import("../views/eu/Faq/pages/FaqSection"));

  const FaqBasics = lazy(() => import("../views/Faq/pages/FaqBasics"));
  const EuFaqBasics = lazy(() => import("../views/eu/Faq/pages/FaqBasics"));

  const ManageAccount = lazy(() => import("../views/Faq/pages/ManageAccount"));
  const EuManageAccount = lazy(() =>
    import("../views/eu/Faq/pages/ManageAccount")
  );

  const DepositFunds = lazy(() => import("../views/Faq/pages/DepositFunds"));
  const EuDepositFunds = lazy(() =>
    import("../views/eu/Faq/pages/DepositFunds")
  );

  const SendMoney = lazy(() => import("../views/Faq/pages/SendMoney"));
  const EuSendMoney = lazy(() => import("../views/eu/Faq/pages/SendMoney"));

  const WithdrawFunds = lazy(() => import("../views/Faq/pages/WithdrawFunds"));
  const EuWithdrawFunds = lazy(() =>
    import("../views/eu/Faq/pages/WithdrawFunds")
  );

  const Cancellation = lazy(() => import("../views/Faq/pages/Cancellation"));
  const EuCancellation = lazy(() =>
    import("../views/eu/Faq/pages/Cancellation")
  );

  const Customer = lazy(() => import("../views/Faq/pages/Customer"));
  const EuCustomer = lazy(() => import("../views/eu/Faq/pages/Customer"));

  //faq internal page
  const BankTransfer = lazy(() =>
    import("../views/Faq/internalPages/BankTransfer")
  );
  const EuBankTransfer = lazy(() =>
    import("../views/eu/Faq/internalPages/BankTransfer")
  );

  const MobileWallet = lazy(() =>
    import("../views/Faq/internalPages/MobileWallet")
  );
  const EuMobileWallet = lazy(() =>
    import("../views/eu/Faq/internalPages/MobileWallet")
  );

  const CashPickup = lazy(() =>
    import("../views/Faq/internalPages/CashPickup")
  );
  const EuCashPickup = lazy(() =>
    import("../views/eu/Faq/internalPages/CashPickup")
  );

  const CardFaq = lazy(() => import("../views/Faq/internalPages/Card"));
  const EuCardFaq = lazy(() => import("../views/eu/Faq/internalPages/Card"));

  const CreateAccount = lazy(() =>
    import("../views/Faq/internalPages/CreateAccount")
  );
  const EuCreateAccount = lazy(() =>
    import("../views/eu/Faq/internalPages/CreateAccount")
  );

  const KycFaq = lazy(() => import("../views/Faq/Kyc"));
  const EuKycFaq = lazy(() => import("../views/eu/Faq/Kyc"));

  const PasswordFaq = lazy(() => import("../views/Faq/Passwords"));
  const EuPasswordFaq = lazy(() => import("../views/eu/Faq/Passwords"));

  const TwoFa = lazy(() => import("../views/Faq/TwoFa"));
  const EuTwoFa = lazy(() => import("../views/eu/Faq/TwoFa"));

  const DepositFund = lazy(() => import("../views/Faq/Funds"));
  const EuDepositFund = lazy(() => import("../views/eu/Faq/Funds"));

  const WithdrawFund = lazy(() => import("../views/Faq/WithdrawFunds"));
  const EuWithdrawFund = lazy(() => import("../views/eu/Faq/WithdrawFunds"));

  const CardTutorial = lazy(() =>
    import("../views/Faq/internalPages/CardTutorial")
  );
  const EuCardTutorial = lazy(() =>
    import("../views/eu/Faq/internalPages/CardTutorial")
  );

  const SendingFunds = lazy(() =>
    import("../views/Faq/internalPages/SendingFunds")
  );
  const EuSendingFunds = lazy(() =>
    import("../views/eu/Faq/internalPages/SendingFunds")
  );

  const Students = lazy(() => import("../views/students/students"));
  const EuStudents = lazy(() => import("../views/eu/students/students"));

  const Referral = lazy(() => import("../views/Referral/referral"));
  const EuReferral = lazy(() => import("../views/eu/Referral/referral"));

  const TermsReferral = lazy(() => import("../views/Referral/termsReferral"));
  const EuTermsReferral = lazy(() =>
    import("../views/eu/Referral/termsReferral")
  );

  // countries pages
  const Philippines = lazy(() => import("../views/countries/Philippines"));
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        }
      />
      <Route
        path="/eu"
        element={
          <Suspense fallback={<Loading />}>
            <EuHome />
          </Suspense>
        }
      />
      {/* <Route
        path="/eu/remittance"
        element={
          <Suspense fallback={<Loading />}>
            <EuRemittance />
          </Suspense>
        }
      /> */}
      <Route
        path="/eu/privacy-policy"
        element={
          <Suspense fallback={<Loading />}>
            <PrivacyPollicy />
          </Suspense>
        }
      />
      <Route
        path="/eu/cookie-policy"
        element={
          <Suspense fallback={<Loading />}>
            <EuCookie />
          </Suspense>
        }
      />
      <Route
        path="/eu/aml"
        element={
          <Suspense fallback={<Loading />}>
            <EuAml />
          </Suspense>
        }
      />
      {/* countries */}
      <Route
        path="remittance/send-money-to-philippines"
        element={
          <Suspense fallback={<Loading />}>
            <Philippines />
          </Suspense>
        }
      />
      <Route
        path="share-your-story"
        element={
          <Suspense fallback={<Loading />}>
            <Story />
          </Suspense>
        }
      />
      <Route
        path="story-wall"
        element={
          <Suspense fallback={<Loading />}>
            <StoryWall />
          </Suspense>
        }
      />
      <Route
        path="story/terms"
        element={
          <Suspense fallback={<Loading />}>
            <TandCStory />
          </Suspense>
        }
      />
      {/** faq section  main pages */}
      <Route
        path="/help"
        element={
          <Suspense fallback={<Loading />}>
            <FaqSection />
          </Suspense>
        }
      />
      <Route
        path="/eu/help"
        element={
          <Suspense fallback={<Loading />}>
            <EuFaqSection />
          </Suspense>
        }
      />
      <Route
        path="/basics"
        element={
          <Suspense fallback={<Loading />}>
            <FaqBasics />
          </Suspense>
        }
      />
      <Route
        path="/eu/basics"
        element={
          <Suspense fallback={<Loading />}>
            <EuFaqBasics />
          </Suspense>
        }
      />
      <Route
        path="/manageaccount"
        element={
          <Suspense fallback={<Loading />}>
            <ManageAccount />
          </Suspense>
        }
      />
      <Route
        path="/eu/manageaccount"
        element={
          <Suspense fallback={<Loading />}>
            <EuManageAccount />
          </Suspense>
        }
      />
      <Route
        path="/depositfunds"
        element={
          <Suspense fallback={<Loading />}>
            <DepositFunds />
          </Suspense>
        }
      />
      <Route
        path="/eu/depositfunds"
        element={
          <Suspense fallback={<Loading />}>
            <EuDepositFunds />
          </Suspense>
        }
      />
      <Route
        path="/sendmoney"
        element={
          <Suspense fallback={<Loading />}>
            <SendMoney />
          </Suspense>
        }
      />
      <Route
        path="/eu/sendmoney"
        element={
          <Suspense fallback={<Loading />}>
            <EuSendMoney />
          </Suspense>
        }
      />
      <Route
        path="/withdrawfunds"
        element={
          <Suspense fallback={<Loading />}>
            <WithdrawFunds />
          </Suspense>
        }
      />
      <Route
        path="/eu/withdrawfunds"
        element={
          <Suspense fallback={<Loading />}>
            <EuWithdrawFunds />
          </Suspense>
        }
      />
      <Route
        path="/cancellations-refunds"
        element={
          <Suspense fallback={<Loading />}>
            <Cancellation />
          </Suspense>
        }
      />
      <Route
        path="/eu/cancellations-refunds"
        element={
          <Suspense fallback={<Loading />}>
            <EuCancellation />
          </Suspense>
        }
      />
      <Route
        path="/customersupport"
        element={
          <Suspense fallback={<Loading />}>
            <Customer />
          </Suspense>
        }
      />
      <Route
        path="/eu/customersupport"
        element={
          <Suspense fallback={<Loading />}>
            <EuCustomer />
          </Suspense>
        }
      />
      {/** faq section  internal pages */}
      <Route
        path="/banktransfer"
        element={
          <Suspense fallback={<Loading />}>
            <BankTransfer />
          </Suspense>
        }
      />
      <Route
        path="/eu/banktransfer"
        element={
          <Suspense fallback={<Loading />}>
            <EuBankTransfer />
          </Suspense>
        }
      />
      <Route
        path="/mobilewallet"
        element={
          <Suspense fallback={<Loading />}>
            <MobileWallet />
          </Suspense>
        }
      />
      <Route
        path="/eu/mobilewallet"
        element={
          <Suspense fallback={<Loading />}>
            <EuMobileWallet />
          </Suspense>
        }
      />
      <Route
        path="/cashpickup"
        element={
          <Suspense fallback={<Loading />}>
            <CashPickup />
          </Suspense>
        }
      />
      <Route
        path="/eu/cashpickup"
        element={
          <Suspense fallback={<Loading />}>
            <EuCashPickup />
          </Suspense>
        }
      />
      <Route
        path="/card"
        element={
          <Suspense fallback={<Loading />}>
            <CardFaq />
          </Suspense>
        }
      />
      <Route
        path="/eu/card"
        element={
          <Suspense fallback={<Loading />}>
            <EuCardFaq />
          </Suspense>
        }
      />
      <Route
        path="/create-account"
        element={
          <Suspense fallback={<Loading />}>
            <CreateAccount />
          </Suspense>
        }
      />
      <Route
        path="/eu/create-account"
        element={
          <Suspense fallback={<Loading />}>
            <EuCreateAccount />
          </Suspense>
        }
      />
      <Route
        path="/kyc-faq"
        element={
          <Suspense fallback={<Loading />}>
            <KycFaq />
          </Suspense>
        }
      />
      <Route
        path="/eu/kyc-faq"
        element={
          <Suspense fallback={<Loading />}>
            <EuKycFaq />
          </Suspense>
        }
      />
      <Route
        path="/password-faq"
        element={
          <Suspense fallback={<Loading />}>
            <PasswordFaq />
          </Suspense>
        }
      />
      <Route
        path="/eu/password-faq"
        element={
          <Suspense fallback={<Loading />}>
            <EuPasswordFaq />
          </Suspense>
        }
      />
      <Route
        path="/2fa"
        element={
          <Suspense fallback={<Loading />}>
            <TwoFa />
          </Suspense>
        }
      />
      <Route
        path="/eu/2fa"
        element={
          <Suspense fallback={<Loading />}>
            <EuTwoFa />
          </Suspense>
        }
      />
      <Route
        path="/card-tutorial"
        element={
          <Suspense fallback={<Loading />}>
            <CardTutorial />
          </Suspense>
        }
      />
      <Route
        path="/eu/card-tutorial"
        element={
          <Suspense fallback={<Loading />}>
            <EuCardTutorial />
          </Suspense>
        }
      />
      <Route
        path="/deposit-funds"
        element={
          <Suspense fallback={<Loading />}>
            <DepositFund />
          </Suspense>
        }
      />
      <Route
        path="/eu/deposit-funds"
        element={
          <Suspense fallback={<Loading />}>
            <EuDepositFund />
          </Suspense>
        }
      />
      <Route
        path="/withdraw-funds"
        element={
          <Suspense fallback={<Loading />}>
            <WithdrawFund />
          </Suspense>
        }
      />
      <Route
        path="/eu/withdraw-funds"
        element={
          <Suspense fallback={<Loading />}>
            <EuWithdrawFund />
          </Suspense>
        }
      />
      <Route
        path="/sending-funds"
        element={
          <Suspense fallback={<Loading />}>
            <SendingFunds />
          </Suspense>
        }
      />
      <Route
        path="/eu/sending-funds"
        element={
          <Suspense fallback={<Loading />}>
            <EuSendingFunds />
          </Suspense>
        }
      />
      <Route
        path="/blog"
        element={
          <Suspense fallback={<Loading />}>
            <Blog />
          </Suspense>
        }
      />
      <Route
        path="/blog/what-is-remittance"
        element={
          <Suspense fallback={<Loading />}>
            <FeaturedPost />
          </Suspense>
        }
      />
      <Route
        path="/blog/the-growth-of-panamas-economy"
        element={
          <Suspense fallback={<Loading />}>
            <PanamaCanal />
          </Suspense>
        }
      />
      <Route
        path="/blog/how-to-avoid-scams-unsolicited-payments"
        element={
          <Suspense fallback={<Loading />}>
            <ScamBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/cheap-ways-to-transfer-money-overseas"
        element={
          <Suspense fallback={<Loading />}>
            <MoneyTransfer />
          </Suspense>
        }
      />
      <Route
        path="/blog/transfer-large-amounts-of-money-to-thailand"
        element={
          <Suspense fallback={<Loading />}>
            <ThailandBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/switching-remittance-companies"
        element={
          <Suspense fallback={<Loading />}>
            <SwitchingRemittance />
          </Suspense>
        }
      />
      <Route
        path="/blog/why-people-are-investing-in-property-overseas"
        element={
          <Suspense fallback={<Loading />}>
            <PropertyOverseas />
          </Suspense>
        }
      />
      <Route
        path="/blog/the-future-is-bright-for-the-dominican-republic"
        element={
          <Suspense fallback={<Loading />}>
            <DominicanRepublic />
          </Suspense>
        }
      />
      <Route
        path="/blog/mexicos-economic-growth-to-continue"
        element={
          <Suspense fallback={<Loading />}>
            <MexicoGrowth />
          </Suspense>
        }
      />
      <Route
        path="/blog/the-economic-outlook-for-el-salvador"
        element={
          <Suspense fallback={<Loading />}>
            <EconomicOutlook />
          </Suspense>
        }
      />
      <Route
        path="/blog/is-ai-the-fix-for-canadas-economy"
        element={
          <Suspense fallback={<Loading />}>
            <AiCanda />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-overseas-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <AusOverseas />
          </Suspense>
        }
      />
      <Route
        path="/blog/anti-money-laundering"
        element={
          <Suspense fallback={<Loading />}>
            <AmlBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/considerations-for-sending-money"
        element={
          <Suspense fallback={<Loading />}>
            <SpecialBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/cash-remittance"
        element={
          <Suspense fallback={<Loading />}>
            <CashRemittanceBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/how-is-foreign-exchange-rate-calculated"
        element={
          <Suspense fallback={<Loading />}>
            <FxRateBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/mid-market-exchange-rate"
        element={
          <Suspense fallback={<Loading />}>
            <MidMarketBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/international-money-transfer-regulations"
        element={
          <Suspense fallback={<Loading />}>
            <InternationalMoney />
          </Suspense>
        }
      />
      <Route
        path="/blog/transfer-money-to-africa"
        element={
          <Suspense fallback={<Loading />}>
            <Africa />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-card"
        element={
          <Suspense fallback={<Loading />}>
            <DebitCardBlog />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-guinea-conakry-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Guinea />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-benin-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Benin />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-burkina-faso-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Burkina />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-cameroon-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Cameroon />
          </Suspense>
        }
      />
      <Route
        path="blog/send-money-to-cote-divoire-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Cote />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-congo-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Congo />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-ghana-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Ghana />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-kenya-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Kenya />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-liberia-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Liberia />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-malawi-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Malawi />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-rwanda-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Rwanda />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-senegal-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Senegal />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-sudan-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Sudan />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-tanzania-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Tanzania />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-uganda-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Uganda />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-zambia-from-australia"
        element={
          <Suspense fallback={<Loading />}>
            <Zambia />
          </Suspense>
        }
      />
      {/**blogs of airtel money,mtn,moov,cash pick up and vodafone. **/}
      <Route
        path="/blog/send-money-to-tanzania-airtel-money"
        element={
          <Suspense fallback={<Loading />}>
            <TanzaniaAirtel />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-Ghana-cash-pick-up"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaCpu />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-benin-through-moov"
        element={
          <Suspense fallback={<Loading />}>
            <BeninMoov />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-Cameroon-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <CameroonMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-ghana-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-ghana-through-vodafone"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaVodafone />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-Ivory-Coast-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <IvoryMTN />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-liberia-through-mtn"
        element={
          <Suspense fallback={<Loading />}>
            <LiberiaMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-senegal-through-orange-mobile-money"
        element={
          <Suspense fallback={<Loading />}>
            <SenegalOMM />
          </Suspense>
        }
      />
      <Route
        path="/blog/send-money-to-South-Sudan-through-mGurush"
        element={
          <Suspense fallback={<Loading />}>
            <SudanGurush />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Rwanda-through-Airtel-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <RwandaAirtel />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-congo-drc-through-Airtel-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <CongoAirtel />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-Money-to-Kenya-through-Bank-transfer"
        element={
          <Suspense fallback={<Loading />}>
            <KeneyaBt />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Malawi-through-Airtel-Money"
        element={
          <Suspense fallback={<Loading />}>
            <MalawiAirtel />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Ghana-through-Zeepay"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaZeepay />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Tanzania-through-Vodacom-M-PESA"
        element={
          <Suspense fallback={<Loading />}>
            <TanzaniaVodacom />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Cameroon-through-Orange-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <CameroonOrange />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Ghana-through-Bank-Transfer"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaBt />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-Money-to-Kenya-through-M-PESA"
        element={
          <Suspense fallback={<Loading />}>
            <KeneyaMPESA />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Ghana-through-Airtel-Tigo-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaAirtel />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Burkina-Faso-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <BurkinaMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Uganda-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <UgandaMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Benin-through-MTN"
        element={
          <Suspense fallback={<Loading />}>
            <BeninMtn />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Congo-DRC-through-Orange-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <CongoOrange />
          </Suspense>
        }
      />
      <Route
        path="/blog/Send-money-to-Uganda-through-Orange-Mobile-Money"
        element={
          <Suspense fallback={<Loading />}>
            <UgandaOrange />
          </Suspense>
        }
      />
      <Route
        path="/blog/Orange-Mobile-Money-Send-money-to-Guinea-Conakry"
        element={
          <Suspense fallback={<Loading />}>
            <GuineaOrange />
          </Suspense>
        }
      />
      <Route
        path="/blog/retirement-in-the-philippines"
        element={
          <Suspense fallback={<Loading />}>
            <PhilippinesRetirement />
          </Suspense>
        }
      />
      <Route
        path="/blog/the-philippine-educational-system"
        element={
          <Suspense fallback={<Loading />}>
            <PhilippinesEducation />
          </Suspense>
        }
      />
      <Route
        path="/blog/cost-of-living-breakdown-in-philippines"
        element={
          <Suspense fallback={<Loading />}>
            <PhilippinesLiving />
          </Suspense>
        }
      />
      <Route
        path="/blog/starting-a-family-in-the-philippines"
        element={
          <Suspense fallback={<Loading />}>
            <PhilippinesFamily />
          </Suspense>
        }
      />
      <Route
        path="/blog/right-health-insurance-plan-in-the-philippines"
        element={
          <Suspense fallback={<Loading />}>
            <PhilippinesHealth />
          </Suspense>
        }
      />
      <Route
        path="/blog/discover-10-must-try-dishes-from-thailand"
        element={
          <Suspense fallback={<Loading />}>
            <ThaiFood />
          </Suspense>
        }
      />
      <Route
        path="/blog/india-response-to-ram-mandir"
        element={
          <Suspense fallback={<Loading />}>
            <RamMandir />
          </Suspense>
        }
      />
      <Route
        path="/blog/india-to-become-world-third-biggest-economy"
        element={
          <Suspense fallback={<Loading />}>
            <IndianEconomy />
          </Suspense>
        }
      />
      <Route
        path="/blog/tourist-hotspot-bali"
        element={
          <Suspense fallback={<Loading />}>
            <IndonesiaBali />
          </Suspense>
        }
      />
      <Route
        path="/blog/culinary-journey-across-Indonesia"
        element={
          <Suspense fallback={<Loading />}>
            <IndonesiaCusine />
          </Suspense>
        }
      />
      <Route
        path="/blog/rich-cultural-heritage-indonesia"
        element={
          <Suspense fallback={<Loading />}>
            <IndonesiaCultural />
          </Suspense>
        }
      />
      <Route
        path="/blog/most-beautiful-beaches-thailand"
        element={
          <Suspense fallback={<Loading />}>
            <ThailandBeaches />
          </Suspense>
        }
      />
      <Route
        path="/blog/thailand-festivals-and-parade"
        element={
          <Suspense fallback={<Loading />}>
            <ThailandCulture />
          </Suspense>
        }
      />
      <Route
        path="/blog/temples-of-thailand"
        element={
          <Suspense fallback={<Loading />}>
            <ThailandTemple />
          </Suspense>
        }
      />
      <Route
        path="/blog/bangkok-beyond-the-chaos"
        element={
          <Suspense fallback={<Loading />}>
            <ThailandBangkok />
          </Suspense>
        }
      />
      <Route
        path="/blog/e-pockets-slick-new-look"
        element={
          <Suspense fallback={<Loading />}>
            <Epocket />
          </Suspense>
        }
      />

      <Route
        path="/blog/ghana-looks-set-for-an-economic-recovery"
        element={
          <Suspense fallback={<Loading />}>
            <GhanaEconomy />
          </Suspense>
        }
      />
      <Route
        path="/blog/the-state-of-the-nigerias-economy"
        element={
          <Suspense fallback={<Loading />}>
            <NigeriaEconomy />
          </Suspense>
        }
      />
      <Route
        path="/blog/will-the-south-african-economy-recover"
        element={
          <Suspense fallback={<Loading />}>
            <SouthAfricaEconomy />
          </Suspense>
        }
      />
      <Route
        path="/blog/melbournes-best-indian-restaurants"
        element={
          <Suspense fallback={<Loading />}>
            <Melbourne />
          </Suspense>
        }
      />
      <Route
        path="/About"
        element={
          <Suspense fallback={<Loading />}>
            <About />
          </Suspense>
        }
      />
      <Route
        path="/eu/About"
        element={
          <Suspense fallback={<Loading />}>
            <EuAbout />
          </Suspense>
        }
      />
      <Route
        path="/Remittance"
        element={
          <Suspense fallback={<Loading />}>
            <Remittance />
          </Suspense>
        }
      />
      <Route
        path="/Vault"
        element={
          <Suspense fallback={<Loading />}>
            <Vault />
          </Suspense>
        }
      />
      <Route
        path="/Ept"
        element={
          <Suspense fallback={<Loading />}>
            <Ept />
          </Suspense>
        }
      />
      <Route
        path="/TandC"
        element={
          <Suspense fallback={<Loading />}>
            <TandC />
          </Suspense>
        }
      />
      <Route
        path="/eu/TandC"
        element={
          <Suspense fallback={<Loading />}>
            <EuTandC />
          </Suspense>
        }
      />
      <Route
        path="/Privacy"
        element={
          <Suspense fallback={<Loading />}>
            <Privacy />
          </Suspense>
        }
      />

      <Route
        path="/ProductDisclosure"
        element={
          <Suspense fallback={<Loading />}>
            <ProductDisclosure />
          </Suspense>
        }
      />

      <Route
        path="/students"
        element={
          <Suspense fallback={<Loading />}>
            <Students />
          </Suspense>
        }
      />
      {/*<Route
        path="/eu/students"
        element={
          <Suspense fallback={<Loading />}>
            <EuStudents />
          </Suspense>
        }
      />*/}
      <Route
        path="/referral"
        element={
          <Suspense fallback={<Loading />}>
            <Referral />
          </Suspense>
        }
      />
      <Route
        path="/eu/referral"
        element={
          <Suspense fallback={<Loading />}>
            <EuReferral />
          </Suspense>
        }
      />
      <Route
        path="/referral/tandc"
        element={
          <Suspense fallback={<Loading />}>
            <TermsReferral />
          </Suspense>
        }
      />
      <Route
        path="/eu/referral/tandc"
        element={
          <Suspense fallback={<Loading />}>
            <EuTermsReferral />
          </Suspense>
        }
      />
    </Routes>
  );
};
